import { VueConstructor } from 'vue'
import { HadesUseOptions } from '../types'

export function install(Vue: VueConstructor, args: HadesUseOptions = {}) {
  if ((install as any).installed) return
  ;(install as any).installed = true

  const components = args.components || {}

  ;(function registerComponents(components: any) {
    if (components) {
      for (const key in components) {
        const component = components[key]
        if (component && !registerComponents(component.hades_subcomponent)) {
          Vue.component(key, component as typeof Vue)
        }
      }
      return true
    }
    return false
  })(components)
}
